import React from 'react';
import PropTypes from 'prop-types';

const MatchedFeatureItem = ({ feature: { key, value }, color }) => (
  <tr>
    <th style={{ color }}>{key}</th>
    <td style={{ color }}>{value}</td>
  </tr>
);

MatchedFeatureItem.propTypes = {
  feature: PropTypes.shape({
    key: PropTypes.string,
    value: PropTypes.string,
  }),
  color: PropTypes.string,
};

export default MatchedFeatureItem;
